import css from 'styled-jsx/css';

const styles = css.global`html.scroll-disabled {
  overflow: hidden !important;
}


#modal-disclaimer {
  padding-top: 20px;
  position: relative;
  
}

#modal-disclaimer #openModal {
  font-family: 'SantanderText';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  color: #000000;
  text-align: center;
  display: block;
  cursor: pointer;
}


#modal-disclaimer #notOpenModal {
  font-family: 'SantanderText';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  color: #000000;
  text-align: center;
}

#modal-disclaimer #openModal b {
  color: #cc0000;
  font-weight: 600;
}

#modal-disclaimer #text-disclaimer {
  font-family: 'SantanderText';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: #000000;
  text-align: center;
}

#modal-disclaimer #openModal b:hover {
  text-decoration: underline;
}

#modal-disclaimer #modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  padding: 20px;
  border: 1px solid #222;
  border-radius: 5px;
  width: 80%;
  z-index: 10000;
}

#modal-disclaimer #modal p {
  font-family: 'SantanderText';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #000000;
  text-align: center;
}

#modal-disclaimer #modal p a {
  font-family: 'SantanderText';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #cc0000;
}
#modal-disclaimer #modal p a:hover {
  text-decoration: underline;
}

#modal-disclaimer #closeBtn {
  background: none;
  border: none;
  width: 100%;
  text-align: right;
  outline: none;
}

#modal-disclaimer #closeBtn img {
  cursor: pointer;
}

#backgroudModal {
  background-color: rgba(34, 34, 34, 0.6);
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9999;
  top: 0;
}


@media (min-width: 992px) {
  #modal-disclaimer #modal {
    max-width: 900px;
    width: 100%;
  }

}`;

export default styles;